import React from "react";
import { HiOutlineSearch } from "react-icons/hi";
import { HiOutlineTableCells, HiOutlineRocketLaunch } from "react-icons/hi2";

const EmptyState = ({ type, isDarkMode }) => {
  const isNoData = type === "noData";
  const isNoMatchingData = type === "noMatchingData";
  const isNoTables = type === "noTables";
  const isNoTableSelected = type === "noTableSelected";

  let message, description, Icon;

  if (isNoTables) {
    message = "No data yet";
    description = "Start using our extraction tools to see your data here";
    Icon = HiOutlineRocketLaunch;
  } else if (isNoTableSelected) {
    message = "No table selected";
    description = "Select a table from the sidebar to view its data";
    Icon = HiOutlineTableCells;
  } else if (isNoData) {
    message = "No data available";
    description = "This table doesn't have any data yet";
    Icon = HiOutlineTableCells;
  } else if (isNoMatchingData) {
    message = "No results found";
    description = "Try adjusting your search terms or clearing filters";
    Icon = HiOutlineSearch;
  } else {
    message = "No data";
    description = "No data to display";
    Icon = HiOutlineTableCells;
  }

  return (
    <div className="flex flex-col items-center justify-center h-full w-full absolute inset-0 p-8 text-center">
      <div className="flex flex-col items-center gap-4 max-w-sm">
        {/* Icon container */}
        <div className={`w-16 h-16 rounded-2xl flex items-center justify-center ${
          isDarkMode
            ? "bg-white/[0.04] border border-white/[0.06]"
            : "bg-gray-100 border border-gray-200"
        }`}>
          <Icon className={`w-8 h-8 ${isDarkMode ? "text-gray-500" : "text-gray-400"}`} />
        </div>

        {/* Message */}
        <div className="flex flex-col gap-1.5">
          <h3 className={`text-base font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-900"}`}>
            {message}
          </h3>
          <p className={`text-sm ${isDarkMode ? "text-gray-500" : "text-gray-500"}`}>
            {description}
          </p>
        </div>
      </div>
    </div>
  );
};

export default EmptyState;
